import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PiInfo } from "react-icons/pi";

import { Buttton, Inputs } from "../../../components";
import { useDispatch } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { useAlert, useToast } from "../../../contexts";
import { useLocation, useNavigate } from "react-router-dom";

const ComposeMessage = ({ loginData, setActiveTab }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { msg } = location.state || {};
  const { showAlert } = useAlert();
  const { showToast } = useToast();
  const [credentials, setCredentials] = useState({
    title: "",
    description: "",
    doctorGuid: loginData.userGuid,
  });

  useEffect(() => {
    if (msg) {
      setCredentials((prev) => {
        const updatedCredentials = {
          ...prev,
          title: msg.title || prev.title,
          description: msg.description || prev.description,
          massMessageGuid: msg.massMessageGuid,
        };
        if (msg.massMessageGuid) {
          delete updatedCredentials.doctorGuid;
        }

        return updatedCredentials;
      });
    }
  }, [msg]);

  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prevCredentials) => ({
      ...prevCredentials,
      [name]: value,
    }));
  };

  const onSave = () => {
    dispatch(
      actionDoctor.postCreateMassMessage(credentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.error && error.data.error.ValidationErrors) {
                error.data.error.ValidationErrors.forEach((validationError) => {
                  console.error(
                    `${t("Field")}: ${validationError.Field} - ${t(
                      "Message"
                    )}: ${validationError.Message}`
                  );

                  showAlert(
                    "danger",
                    validationError.Message,
                    `${t("Error")} : ${validationError.Field}`
                  );
                });
              } else {
                showAlert(
                  "danger",
                  `${t("Invalid_credentials")}`,
                  `${t("Error")} !`
                );
              }
            } else {
              showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
            }
          }
        } else if (response) {
          if (response.status === 200) {
            showToast(
              `${t("success")}`,
              `${t("doctor.Mass_Messages.mass_message_sent_successfully")}`,
              5000,
              true,
              "top-end toast-success"
            );
            dispatch(actionDoctor.getMassMessages(loginData.userGuid));
            setCredentials({
              title: "",
              description: "",
              doctorGuid: loginData.userGuid,
            });
            setActiveTab("message-history");
            navigate("/doctor/mass-messages/message-history");
          }
        }
      })
    );
  };
  return (
    <>
      <section className="compose-message-section">
        <div className="compose-message-frm-blk">
          <h5 className="exado-title-six">
            <PiInfo className="info-icn" />
            {t("doctor.Mass_Messages.mass_messages_info")}
          </h5>
          <Form className="compose-message-form">
            <Row className="pro-row pro-row5">
              <Form.Label className="exado-title-seven">
                {t("doctor.Mass_Messages.compose_the_message")}
              </Form.Label>
              <Col md={12}>
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors.title ? (
                        <span className="error-message"> {errors.title}</span>
                      ) : (
                        `${t("Subject")}`
                      )
                    }
                    value={credentials.title}
                    name="title"
                    onChange={handleChange}
                    grpClassname={`form-group ${
                      errors.title ? "form-group-error" : ""
                    }`}
                  />
                </Row>
              </Col>
              <Col md={12} className="pro-col">
                <Row>
                  <Inputs.FormInputs
                    type="textarea"
                    placeholder={t(
                      "profile_page.additional_information.Write_text_here"
                    )}
                    label={
                      errors.description ? (
                        <span className="error-message">
                          {errors.description}
                        </span>
                      ) : (
                        ""
                      )
                    }
                    name="description"
                    value={credentials.description}
                    onChange={handleChange}
                    grpClassname={`form-group ${
                      errors.description ? "form-group-error" : ""
                    }`}
                  />
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="compose-message-btn-blk">
          <Buttton.Buttton
            children={msg?.massMessageGuid ? `${t("Edit")}` : `${t("save")}`}
            className="btn-solid-Aqua_Teal"
            onClick={onSave}
          />
        </div>
      </section>
    </>
  );
};

export default ComposeMessage;
